import * as React from 'react';
import classNames from 'classnames';
import { NavigateFunction } from 'react-router-dom';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { Agency } from '../../reducers/types';
import styles from './styles.pcss';

type Props = {
  agency: Agency;
  navigate: NavigateFunction;
};

const AgencyTableRow = ({ agency, navigate }: Props) => {

  return (
    <TableRow
      className={classNames(styles.clickable, styles.tableRow)}
      key={agency.id}
      onClick={() => navigate(`/agency/${agency.id}`)}
    >
      <TableCell
        className={classNames(styles.tableRowCell)}
        scope="row"
      >
        {agency.friendlyName}
      </TableCell>
      <TableCell className={classNames(styles.tableRowCell)}>
        {agency.appHost}
      </TableCell>
      <TableCell className={classNames(styles.tableRowCell)}></TableCell>
    </TableRow>
  );
};

export default AgencyTableRow;
